import * as complextext from './complex-text/complex-text-widget';
import * as countdown from './countdown/countdown-widget';
import * as customWidget from './custom/custom-widget';
import * as descopeSignup from './descope-signup/descope-signup-widget';
import * as barGraph from './graphs/bar-graph/bar-graph-widget';
import * as HeatMap from './graphs/heat-map/heat-map-widget';
import * as image from './image/image-widget';
import * as inOutCards from './in-out-cards/in-out-cards-widget';
import * as llmTips from './llm-tips/llm-tips-widget';
import * as lottie from './lottie/lottie-widget';
import * as pastMonthsSummary from './past-months-summary/past-months-summary-widget';
import * as poll from './poll/poll-widget';
import * as text from './text/text-widget';
import * as topCategories from './top-categories/top-categories-widget';
import * as transactionList from './transaction-list/transaction-list-widget';
import * as video from './video/video-widget';

export default function availableWidgets() {
  return {
    ...createWidgetWrapper(text),
    ...createWidgetWrapper(complextext),
    ...createWidgetWrapper(image),
    ...createWidgetWrapper(lottie),
    ...createWidgetWrapper(video),
    ...createWidgetWrapper(countdown),
    ...createWidgetWrapper(poll),
    ...createWidgetWrapper(transactionList),
    ...createWidgetWrapper(customWidget),
    ...createWidgetWrapper(barGraph),
    ...createWidgetWrapper(HeatMap),
    ...createWidgetWrapper(llmTips),
    ...createWidgetWrapper(inOutCards),
    ...createWidgetWrapper(descopeSignup),
    ...createWidgetWrapper(topCategories),
    ...createWidgetWrapper(pastMonthsSummary),
  };
}

function createWidgetWrapper(widget) {
  return {
    [widget.type]: {
      view: widget.view,
      builder: widget.builder,
    },
  };
}
